<template>
	<div ref="tablePage" style="height: 100%">
		<!-- 面包屑导航 -->
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/homePage' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>小区管理</el-breadcrumb-item>
				</el-breadcrumb>
				<el-form ref="queryForm" :model="searchForm" inline label-width="68px" style="margin-left: 8vh">
					<el-form-item style="margin-bottom: 0">
						<el-select v-model="searchForm.company_id" placeholder="请选择公司" filterable clearable size="small"
							style="width: 100%" @change="searchChange" @clear="clearInput">
							<el-option v-for="item in companysList" :key="item.id" :label="item.title"
								:value="item.id" />
						</el-select>
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-select v-model="searchForm.city_id" placeholder="请选择城市" filterable clearable size="small"
							@change="searchChange" @clear="clearInput">
							<el-option v-for="item in cityList" :key="item.id" :label="item.title" :value="item.id" />
						</el-select>
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-input v-model="searchForm.title" autocomplete="off" maxlength="30" placeholder="搜索小区"
							clearable @change="searchChange" @clear="clearInput" size="small" />
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-button type="primary" icon="el-icon-search" @click="searchChange"
							size="small">搜索</el-button>
						<el-button icon="el-icon-plus" type="success" @click="handleNewAdd"
							size="small">新增小区</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="medium"
			:default-sort="{ prop: 'id', order: 'descending' }"
			:header-cell-style="{background: '#fff',height: '50px',color: '#909399',fontSize: '16px',fontFamily: 'Arial, sans-serif'}">
			<el-table-column prop="id" label="小区编号" sortable align="center" />
			<el-table-column prop="city_name" label="城市名称" align="center" />
			<el-table-column prop="title" label="小区名称" align="center" />
			<el-table-column prop="title" label="小区图片" align="center">
				<template slot-scope="scope">
					<el-image :src="scope.row.xiaoqu_img" :preview-src-list="[scope.row.xiaoqu_img]"
						style="width: 80px; height: 80px"></el-image>
				</template>
			</el-table-column>
			<el-table-column prop="created_at" label="创建时间" align="center" />
			<!-- <el-table-column prop="status" label="短信跳转直播" align="center">
				<template slot-scope="scope">
					<el-switch active-color="#13ce66" v-model="scope.row.live_status" :active-value="1"
						:inactive-value="0" @change="changeStatus(scope.row)"></el-switch>
				</template>
			</el-table-column> -->
			<el-table-column prop="service_deadline_day" label="到期天数" align="center" />
			<el-table-column prop="status" label="状态" align="center">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
						@change="changeStatus(scope.row)"></el-switch>
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="操作" align="center" width="550">
				<template slot-scope="scope">
					<el-dropdown>
						<el-button type="success" size="small">
							生成<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item>
								<el-button @click.native.prevent="getShortImg(scope.row)" type="text" size="small"
									icon="el-icon-s-grid">生成短码
								</el-button>
							</el-dropdown-item>
							<el-dropdown-item>
								<el-button @click.native.prevent="getShortUrl(scope.row)" type="text" size="small"
									icon="el-icon-document-remove">生成短链</el-button>
							</el-dropdown-item>
							<el-dropdown-item>
								<el-button @click.native.prevent="getappImg(scope.row)" type="text" size="small"
									icon="el-icon-mobile">
									生成小程序码
								</el-button>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<el-dropdown>
						<el-button type="info" size="small">
							查看<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item>
								<el-button @click.native.prevent="getApps(scope.row)" type="text" size="small"
									icon="el-icon-postcard">
									查看小程序码
								</el-button>
							</el-dropdown-item>
							<el-dropdown-item v-if="scope.row.urllink && scope.row.urllink.length">
								<el-button @click.native.prevent="getAppsl(scope.row)" type="text" size="small"
									icon="el-icon-postcard">
									查看小程序短链
								</el-button>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<el-dropdown>
						<el-button type="warning" size="small">
							车库/楼栋/标签<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item>
								<el-button @click.native.prevent="handleCar(scope.row)" type="text" size="small"
									icon="el-icon-truck">
									车库管理
								</el-button>
							</el-dropdown-item>
							<el-dropdown-item>
								<el-button @click.native.prevent="handleBuild(scope.row)" type="text" size="small"
									icon="el-icon-school">
									楼栋管理
								</el-button>
							</el-dropdown-item>
							<el-dropdown-item>
								<el-button @click.native.prevent="handleFloor(scope.row)" type="text" size="small"
									icon="el-icon-office-building">
									小区标签
								</el-button>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<el-dropdown>
						<el-button type="primary" size="small">
							操作<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item>
								<el-button @click.native.prevent="handleClick(scope.row)" type="text" size="small"
									icon="el-icon-edit">
									修改
								</el-button>
							</el-dropdown-item>
							<el-dropdown-item>
								<el-button @click.native.prevent="singleDel(scope.row, scope.row.id)" type="text"
									size="small" icon="el-icon-delete">
									移除
								</el-button>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<el-button @click.native.prevent="handleMessage(scope.row)" type="danger" size="small">
						发送短信
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.size"
			@pagination="initList" />
		<!-- 小程序码弹窗 -->
		<el-dialog :title="title" :visible.sync="appOpen" :close-on-click-modal="false" width="40%"
			class="global-dialog-position">
			<el-image v-if="appUrl && appUrl.length" style="width: 100%; height: 100%" :src="appUrl"
				:preview-src-list="[appUrl]">
			</el-image>
			<div v-if="appShortUrl && appShortUrl.length"
				style="align-items: center; display: flex; width: 100%; height: 80px;">
				<el-input :value="appShortUrl"></el-input>
				<el-button type="primary" @click="saveToClip(appShortUrl)">复制</el-button>
			</div>
		</el-dialog>
		<!-- 添加和修改弹窗 -->
		<el-dialog :title="title" :visible.sync="addOrEditOpen" :close-on-click-modal="false" width="65%"
			class="dialogHeight2 global-dialog-position" :before-close="getout" :lock-scroll="false"
			:append-to-body="true" style="margin-top: -10vh">
			<el-form ref="form" :model="form" label-width="120px" :rules="rules" show-message>
				<el-tabs tab-position="left" :before-leave="checkTab">
					<el-tab-pane label="项目资料">
						<el-row>
							<el-col :span="24">
								<el-form-item label="小区名称" prop="title">
									<el-input v-model="form.title" autocomplete="off" placeholder="请输入" />
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="小区简称" prop="abbreviation">
									<el-input v-model="form.abbreviation" maxlength="5" autocomplete="off"
										placeholder="最多5个字" />
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="所在城市" prop="city_id">
									<el-select v-model="form.city_id" placeholder="请选择" clearable style="width: 100%"
										@change="changeCity">
										<el-option v-for="item in cityList" :key="item.id" :label="item.title"
											:value="item.id" />
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="所在区域">
									<el-select v-model="form.region_id" placeholder="请选择" clearable filterable
										style="width: 100%" @change="changeRegion">
										<el-option v-for="item in regionList" :key="item.id" :label="item.title"
											:value="item.id" />
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="小区地址">
									<el-input v-model="form.address" autocomplete="off" placeholder="请输入" />
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="所属公司" prop="company_id">
									<el-select v-model="form.company_id" placeholder="请选择" clearable filterable
										style="width: 100%">
										<el-option v-for="item in companysList" :key="item.id" :label="item.title"
											:value="item.id" />
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="小区户数" prop="room_num">
									<el-input v-model="form.room_num" autocomplete="off" placeholder="请输入" />
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="分享文案">
									<el-input v-model="form.share_title" autocomplete="off" placeholder="请输入"
										type="textarea" :rows="3" />
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="黑白logo">
									<el-upload class="avatar-uploader" :action="uploadImgUrl" :show-file-list="false"
										:on-success="handleLogoSuccess" :before-upload="beforeAvatarUpload"
										:headers="headers" :disabled="true">
										<div class="avatar-wrapper">
											<el-image v-if="logo_url" :src="logo_url" class="avatar"
												:preview-src-list="[logo_url]" />
											<i v-if="logo_url" class="el-icon-close" @click.stop="removePic3"></i>
											<i v-else class="el-icon-picture-outline avatar-uploader-icon"
												@click="uploadPicIcon"></i>
										</div>
									</el-upload>
									<span style="color: #999; margin-top: -2vh">图片大小建议140*140</span>
									<div class="chooseImg">
										<el-button type="info" @click="chooseImg4(logo_url)">选择图片</el-button>
										<el-input v-model="logo_url" autocomplete="off" placeholder="请输入" />
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="原logo">
									<el-upload class="avatar-uploader" :action="uploadImgUrl" :show-file-list="false"
										:on-success="handleLogoSuccess" :before-upload="beforeAvatarUpload"
										:headers="headers" :disabled="true">
										<div class="avatar-wrapper">
											<el-image v-if="colorful_log" :src="colorful_log" class="avatar"
												:preview-src-list="[colorful_log]" />
											<i v-if="colorful_log" class="el-icon-close" @click.stop="removePic4"></i>
											<i v-else class="el-icon-picture-outline avatar-uploader-icon"
												@click="uploadPicIcon"></i>
										</div>
									</el-upload>
									<span style="color: #999; margin-top: -2vh">图片大小建议140*140</span>
									<div class="chooseImg">
										<el-button type="info" @click="chooseImg5(colorful_log)">选择图片</el-button>
										<el-input v-model="colorful_log" autocomplete="off" placeholder="请输入" />
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="小区列表图">
									<el-upload class="avatar-uploader" :action="uploadImgUrl" :show-file-list="false"
										:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
										:headers="headers" :disabled="true">
										<div class="avatar-wrapper">
											<el-image v-if="imageUrl" :src="imageUrl" class="avatar"
												:preview-src-list="[imageUrl]" />
											<i v-if="imageUrl" class="el-icon-close" @click.stop="removePic"></i>
											<i v-else class="el-icon-picture-outline avatar-uploader-icon"
												@click="uploadPicIcon"></i>
										</div>
									</el-upload>
									<span style="color: #999; margin-top: -2vh">图片大小建议520*160</span>
									<div class="chooseImg">
										<el-button type="info" @click="chooseImg(imageUrl)">选择图片</el-button>
										<el-input v-model="imageUrl" autocomplete="off" placeholder="请输入" />
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="小区首页图">
									<div class="avatar-wrapper" v-for="home_img in form.home_imgs" :key="home_img">
										<el-image v-if="home_img" :src="home_img" :preview-src-list="[form.home_imgs]"
											class="avatar" />
										<i class="el-icon-close" @click.stop="removePic1(home_img)"></i>
										<el-input :value="home_img" disabled autocomplete="off" placeholder="请输入" />
									</div>
									<span style="color: #999; margin-top: -2vh">图片大小建议800*600</span>
									<div class="chooseImg">
										<el-button type="info" @click="chooseImg2()">选择图片</el-button>
									</div>
								</el-form-item>
							</el-col>
						</el-row>
					</el-tab-pane>
					<el-tab-pane label="项目设置">
						<el-row>
							<el-col :span="24">
								<el-form-item label="访问模式" prop="is_hidden">
									<el-radio-group v-model="form.is_hidden">
										<el-radio v-for="item in priceStatus" :label="item.label"
											:key="item.label">{{ item.text }}</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="不跟进最大天数" prop="follow_day">
									<el-input v-model="form.follow_day" autocomplete="off" type="number"
										placeholder="请输入" />
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="客户评分规则">
									<el-select v-model="form.rule_engine_version" placeholder="请选择" clearable filterable
										style="width: 100%">
										<el-option v-for="(item,index) in customerRuleList" :key="index"
											:label="item.version" :value="item.version" />
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="锁定时间(小时)" prop="lock_hour">
									<el-input v-model="form.lock_hour" autocomplete="off" placeholder="请输入锁定时间" />
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="可锁定个数">
									<el-input v-model="form.lock_num" autocomplete="off" placeholder="请输入锁定数量" />
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="跟进超时客户池:">
									<el-switch v-model="form.customer_pool_button" :active-value=1
										:inactive-value=0></el-switch>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="AI判客:">
									<el-switch v-model="form.ai_assessment_button" :active-value=1
										:inactive-value=0></el-switch>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="租售一体:">
									<el-switch v-model="form.rent_sale_integrate" :active-value=1
										:inactive-value=0></el-switch>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="网络电话:">
									<el-switch v-model="form.call_recording_button" :active-value=1
										:inactive-value=0></el-switch>
								</el-form-item>
							</el-col>
						<el-col :span="24">
							<el-form-item label="排序">
								<el-input v-model="form.sort" autocomplete="off" placeholder="请输入" />
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="开盘锁定可取消:">
								<el-switch v-model="form.doings_lock_cancel_button" :active-value="1"
									:inactive-value="0"></el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="隐藏首页百分比:">
								<el-switch v-model="form.cp_percent_show" :active-value="0"
									:inactive-value="1"></el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="用户托管开关:">
								<el-switch v-model="form.hosting" :active-value="1"
									:inactive-value="0"></el-switch>
							</el-form-item>
						</el-col>
					</el-row>
				</el-tab-pane>
				<el-tab-pane label="合同管理">
						<el-row>
							<el-col :span="24">
								<el-form-item label="服务版本">
									<el-radio-group v-model="form.service_version">
										<el-radio :label="1">基础版</el-radio>
										<el-radio :label="2">满血版</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="到期时间" prop="service_deadline">
									<el-date-picker v-model="form.service_deadline" value-format="yyyy-MM-dd"
										type="date" placeholder="选择日期" style="width: 100%" @input="changeDate">
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="备注">
									<div style="border: 1px solid #ccc; ">
										<Toolbar style="border-bottom: 1px solid #ccc" :editor="editor0"
											:defaultConfig="toolbarConfig0" :mode="mode" />
										<Editor style="height: 500px; overflow-y: hidden" v-model="form.remark"
											:defaultConfig="editorConfig0" :mode="mode" @onCreated="onCreated0"
											@onChange="onChange0" />
									</div>
								</el-form-item>
							</el-col>
						</el-row>
					</el-tab-pane>
					<el-tab-pane label="活动弹窗">
						<el-row>
							<el-col :span="24">
								<el-form-item label="弹窗图" prop="image">
									<el-upload class="avatar-uploader" :action="uploadImgUrl" :show-file-list="false"
										:on-success="handlecuxiaoSuccess" :before-upload="beforeAvatarUpload"
										:headers="headers" :disabled="true">
										<div class="avatar-wrapper">
											<el-image v-if="form.sales_img" :src="form.sales_img"
												:preview-src-list="[form.sales_img]" class="avatar" />
											<i v-if="form.sales_img" class="el-icon-close" @click.stop="removePic2"></i>
											<i v-else class="el-icon-picture-outline avatar-uploader-icon"
												@click="uploadPicIcon"></i>
										</div>
									</el-upload>
									<span style="color: #999; margin-top: -2vh">图片大小建议600*800</span>
									<div class="chooseImg">
										<el-button type="info" @click="chooseImg3(form.sales_img)">选择图片</el-button>
										<el-input v-model="form.sales_img" autocomplete="off" placeholder="请输入" />
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="弹窗起止日期">
									<el-date-picker v-model="form.date" value-format="yyyy-MM-dd HH:mm:ss"
										type="datetimerange" align="right" unlink-panels range-separator="至"
										start-placeholder="开始时间" end-placeholder="结束时间" :picker-options="pickerOptions"
										style="width: 100%" @input="changeDate">
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="弹窗链接">
									<el-select v-model="form.activity_type" placeholder="请选择" clearable filterable
										style="width: 100%">
										<el-option v-for="item in comAct" :key="item.index" :label="item.value"
											:value="parseInt(item.key)" />
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="公众号地址">
									<el-input v-model="form.gzh_url" autocomplete="off" placeholder="请输入地址" />
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="小程序内部链接">
									<el-input v-model="form.mp_inner_link" autocomplete="off" placeholder="请输入地址" />
								</el-form-item>
							</el-col>
						</el-row>
					</el-tab-pane>
					<el-tab-pane label="企微客服">
						<el-row>
							<el-col :span="24">
								<el-form-item label="微信客服企业ID">
									<el-input v-model="form.wechat_bot_enterprise_id" autocomplete="off"
										placeholder="请输入客服企业ID" />
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="微信客服链接">
									<el-input v-model="form.wechat_bot_link" autocomplete="off" placeholder="请输入客服链接" />
								</el-form-item>
							</el-col>
						</el-row>
					</el-tab-pane>
					<el-tab-pane label="选位须知">
						<el-row>
							<el-col :span="24">
								<el-form-item label="选位须知">
									<div style="border: 1px solid #ccc; ">
										<Toolbar style="border-bottom: 1px solid #ccc" :editor="editor"
											:defaultConfig="toolbarConfig" :mode="mode" />
										<Editor style="height: 500px; overflow-y: hidden" v-model="form.choose_notice"
											:defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated"
											@onChange="onChange" />
									</div>
								</el-form-item>
							</el-col>
						</el-row>
					</el-tab-pane>
				<el-tab-pane label="预约停车">
					<el-row>
						<el-col :span="24">
							<el-form-item label="预约停车开关:">
								<el-switch v-model="form.booking_parking" :active-value=1
									:inactive-value=0></el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="预约默认天数">
								<el-input v-model="form.book_limit_day" autocomplete="off"
									placeholder="请输入预约默认天数" />
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="预约停车须知">
								<div style="border: 1px solid #ccc; ">
									<Toolbar style="border-bottom: 1px solid #ccc" :editor="editor1"
										:defaultConfig="toolbarConfig1" :mode="mode" />
									<Editor style="height: 500px; overflow-y: hidden"
										v-model="form.booking_park_notice" :defaultConfig="editorConfig1"
										:mode="mode" @onCreated="onCreated1" @onChange="onChange1" />
								</div>
							</el-form-item>
						</el-col>
					</el-row>
				</el-tab-pane>
				<el-tab-pane label="租赁">
					<el-row>
						<el-col :span="24">
							<el-form-item label="启用租赁:">
								<el-switch v-model="form.rent_pay_button" :active-value="1"
									:inactive-value="0"></el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="租赁协议">
								<div style="border: 1px solid #ccc;">
									<Toolbar style="border-bottom: 1px solid #ccc" :editor="editor2"
										:defaultConfig="toolbarConfig2" :mode="mode" />
									<Editor style="height: 400px; overflow-y: hidden" v-model="form.rent_contract"
										:defaultConfig="editorConfig2" :mode="mode" @onCreated="onCreated2"
										@onChange="onChange2" />
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="租期配置">
								<div style="margin-bottom: 10px;">
									<el-button type="primary" size="small" icon="el-icon-plus"
										@click="addRentRule">添加租期</el-button>
								</div>
								<el-table :data="form.rent_price_rule_vos" border size="small"
									style="width: 100%"
									:header-cell-style="{background:'#f5f7fa',color:'#606266',fontWeight:'600'}">
									<el-table-column label="租期（天）" align="center">
										<template slot-scope="scope">
											<el-input-number v-model="scope.row.tenancy" :min="1" :precision="0"
												controls-position="right" size="small"
												style="width: 120px"></el-input-number>
										</template>
									</el-table-column>
									<el-table-column label="租金（元）" align="center">
										<template slot-scope="scope">
											<el-input-number v-model="scope.row.rent_price" :min="0" :precision="2"
												controls-position="right" size="small"
												style="width: 140px"></el-input-number>
										</template>
									</el-table-column>
									<el-table-column label="操作" align="center" width="100">
										<template slot-scope="scope">
											<el-button type="danger" size="mini" icon="el-icon-delete"
												@click="removeRentRule(scope.$index)">删除</el-button>
										</template>
									</el-table-column>
								</el-table>
								<div v-if="!form.rent_price_rule_vos || form.rent_price_rule_vos.length === 0"
									style="text-align:center;color:#909399;padding:20px 0;font-size:13px;">
									暂无租期配置，点击「添加租期」新增
								</div>
							</el-form-item>
						</el-col>
					</el-row>
				</el-tab-pane>
			</el-tabs>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForms">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>
		<el-dialog title="图片" :visible.sync="upImg" :close-on-click-modal="false" width="85%"
			class="dialogHeight global-dialog-position" style="margin-top: -12vh">
			<imgUpload ref="imgUpload" />
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitFormz">确 定</el-button>
			</div>
			<div slot="body" style="height: 50vh"></div>
		</el-dialog>
	</div>
</template>

<script>
	import tableCommon from "../../../mixins/table-common";
	import citySearch from "../../components/citySearch.vue";
	import {
		getCityeList
	} from "../../api/city";
	import {
		getdistrictList
	} from "../../api/district";
	import {
		getCompanysList
	} from "../../api/userMG";
	import {
		getCookie,
		copyTextToClipboard
	} from "../../utils/util";
	import imgUpload from "../../components/uploadImg.vue";

	import {
		getcommunityList,
		addcommunity,
		editcommunity,
		deletecommunity,
		getappImgs,
		getShort,
		getShortUrl,
		sellMsg,
		getcommunityAct,
		getShowCompany,
		getXsList,
		getCustomerVersionList
	} from "../../api/community";
	import Vue from "vue";
	import {
		Editor,
		Toolbar
	} from "@wangeditor/editor-for-vue";
	import {
		DomEditor,
		Boot
	} from "@wangeditor/editor";

	export default Vue.extend({
		mixins: [tableCommon],
		components: {
			citySearch,
			imgUpload,
			Editor,
			Toolbar
		},
		data() {
			return {
				upImg: false,
				// 小区首页图片
				regionTypes: [{
						label: 1,
						text: "启用",
					},
					{
						label: 0,
						text: "禁用",
					},
				],
				priceStatus: [{
						label: 0,
						text: "能",
					},
					{
						label: 1,
						text: "不能",
					},
					{
						label: 2,
						text: "白名单",
					},
					{
						label: 3,
						text: "需授权",
					},
          {
            label: 4,
            text: "客户端维护",
          },
				],
				// 时间选择
				timeValue: "",
				// 请求地址api
				api: {
					list: getcommunityList,
					add: addcommunity,
					del: deletecommunity,
					edit: editcommunity,
				},
				// 图片是否预览
				imgDis: false,
				imgDis2: false,
				imgDis3: false,
				imgDis4: false,
				imgDis5: false,
				// 规则验证
				rules: {
					city_id: [{
						required: true,
						message: "请选择所在城市",
						trigger: "change"
					}, ],
					company_id: [{
						required: true,
						message: "请选择所属公司",
						trigger: "change"
					}, ],
					title: [{
						required: true,
						message: "请输入小区名",
						trigger: "blur"
					}],
					abbreviation: [{
						required: true,
						message: "请输入小区简称",
						trigger: "blur"
					}],
					follow_day: [{
						required: true,
						message: "请输入不跟进最大天数",
						trigger: "blur"
					}, ],
					room_num: [{
						required: true,
						pattern: /^[1-9]\d*$/,
						message: "户数必须为正整数且不能为零",
					}, ],
					lock_hour: [{
						pattern: /^\d+$/,
						message: "只能输入正整数小时"
					}],
				},
				// 传参
				form: {
					status: "1",
				},
				// 弹窗标题
				title: "新增",
				addOrEditOpen: false,
				// 查询参数
				searchForm: {
					page: 1,
					size: 10,
				},
				searchFormS: {}, // 销售权限
				tableData: [],
				// 弹窗显隐
				appOpen: false,
				// 小程序码
				appUrl: "",
				// 小程序短链
				appShortUrl: "",
				// 所在城市
				cityList: "",
				// 所在区域列表
				regionList: "",
				// 所属公司下拉
				companysList: "",
				// 销售类型
				xsTypes: [{
					id: 1,
					title: '顾问'
				}, {
					id: 2,
					title: '经理'
				}],
				// 销售列表数据
				xsData: [],
				imageUrl: "",
				logo_url: "",
				colorful_log: "",
				// 上传头文件
				headers: {
					Authorization: "Bearer " + getCookie("logintoken"),
				},
				// 图片上传地址
				uploadImgUrl: process.env.VUE_APP_URL + "/admin/uploadFile",
				// 第一张图片唤起
				imgFirst: false,
				imgSecond: false,
				imgThird: false,
				imgFour: false,
				imgFive: false,
				comAct: "",
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				customerRuleList: [],
			editor: null,
			editor0: null,
			editor1: null,
			editor2: null,
			toolbarConfig: {
				excludeKeys: ["group-video"],
			},
			toolbarConfig0: {
				excludeKeys: ["group-video"],
			},
			toolbarConfig1: {
				excludeKeys: ["group-video"],
			},
			toolbarConfig2: {
				excludeKeys: ["group-video"],
			},
				editorConfig: {
					placeholder: "请输入内容...",
					MENU_CONF: {
						uploadImage: {
							server: process.env.VUE_APP_URL + "/admin/uploadFile",
							fieldName: "file",
							// 上传头文件
							headers: {
								Authorization: "Bearer " + getCookie("logintoken"),
							},
							customInsert(res, insertFn) {
								// JS 语法
								const urls = res.data.path;
								insertFn(urls);
							},
						},
					},
				},
				editorConfig0: {
					placeholder: "请输入内容...",
					MENU_CONF: {
						uploadImage: {
							server: process.env.VUE_APP_URL + "/admin/uploadFile",
							fieldName: "file",
							// 上传头文件
							headers: {
								Authorization: "Bearer " + getCookie("logintoken"),
							},
							customInsert(res, insertFn) {
								// JS 语法
								const urls = res.data.path;
								insertFn(urls);
							},
						},
					},
				},
			editorConfig1: {
				placeholder: "请输入内容...",
				MENU_CONF: {
					uploadImage: {
						server: process.env.VUE_APP_URL + "/admin/uploadFile",
						fieldName: "file",
						// 上传头文件
						headers: {
							Authorization: "Bearer " + getCookie("logintoken"),
						},
						customInsert(res, insertFn) {
							// JS 语法
							const urls = res.data.path;
							insertFn(urls);
						},
					},
				},
			},
			editorConfig2: {
				placeholder: "请输入租赁协议内容...",
				MENU_CONF: {
					uploadImage: {
						server: process.env.VUE_APP_URL + "/admin/uploadFile",
						fieldName: "file",
						headers: {
							Authorization: "Bearer " + getCookie("logintoken"),
						},
						customInsert(res, insertFn) {
							const urls = res.data.path;
							insertFn(urls);
						},
					},
				},
			},
				mode: "default", // or 'simple'
			};
		},
		mounted() {
			function withEmptyHtml(editor) {
				const {
					getHtml
				} = editor;
				const newEditor = editor;
				newEditor.getHtml = () => {
					if (newEditor.isEmpty()) {
						return "";
					}
					return getHtml();
				};
				return newEditor;
			}
			Boot.registerPlugin(withEmptyHtml);
			this.getCityeLists();
			this.getCompanysLists();
			this.getComAct();
			getCustomerVersionList().then(res => {
				this.customerRuleList = res.data;
			});
		},
		watch: {
			upImg(newVal) {
				if (newVal) {
					this.$nextTick(() => {
						this.$refs.imgUpload.resetSelect();
					});
				}
			},
			"form.title"(newVal) {
				if (newVal) {
					this.form.share_title = this.form.title + "可以在线选车位啦！";
				}
			},
		},
		methods: {
			// 检测必填输入内容
			checkTab(e) {
				let flag = true;

				if (e > 0 && (!this.form.city_id || !this.form.company_id || !this.form.title || !this.form.abbreviation || !this.form.room_num)) {
					flag = false;
				}

				if (e > 1 && (!this.form.follow_day)) {
					flag = false;
				}

				if (!flag) {
					this.$message.warning('请完成必填项');
				}

				return flag;
			},
			// 复制
			saveToClip(res) {
				let that = this;
				let copyInfo = {
					getText: function() {
						return res;
					},
					success: function() {
						that.$message.success('复制成功')
					}
				}
				copyTextToClipboard(copyInfo);
			},
			// 按公司查询销售
			changeCompany(res) {
				clickSearch();
			},
			// 按销售类型查询
			changeXsType(res) {
				clickSearch();
			},
			// 按姓名查询销售
			searchChangeName(res) {
				clickSearch();
			},
			// 按手机号查询销售
			searchChangePhone(res) {
				clickSearch();
			},
			// 筛选条件触发查询销售
			clickSearch() {
				if (searchFormS.companyId || searchFormS.type || searchFormS.name || searchFormS.mobile) {
					getXsList(searchFormS).then((res) => {
						if (res.code == 200) {
							this.xsData = res.data;
						}
					});
				}
			},
			uploadPicIcon() {
				this.$message.warning("请点击下方选择图片按钮进行上传");
			},
			submitFormz() {
				if (this.$refs.imgUpload.faData.url) {
					if (this.imgFirst && this.$refs.imgUpload.faData.url !== undefined) {
						this.$refs.imgUpload.findTrue();
						this.imageUrl = this.$refs.imgUpload.faData.url;
						this.form.xiaoqu_img = this.$refs.imgUpload.faData.url;
					} else if (this.imgSecond && this.$refs.imgUpload.faData.url !== undefined) {
						// this.$refs.imgUpload.findTrue();
						console.log('图片选择器选择成功：', this.$refs.imgUpload.faDatas)
						var addImgs = []
						this.$refs.imgUpload.faDatas.forEach(item => {
							if (!this.form.home_imgs || !this.form.home_imgs.includes(item.url)) {
								addImgs.push(item.url)
							}
						})
						if (addImgs.length) {
							if (this.form.home_imgs) {
								this.form.home_imgs.splice(0, 0, ...addImgs)
							} else {
								this.form.home_imgs = addImgs
							}
						}
						// this.form.home_img = this.$refs.imgUpload.faData.url;
					} else if (this.imgThird && this.$refs.imgUpload.faData.url !== undefined) {
						this.$refs.imgUpload.findTrue();
						this.form.sales_img = this.$refs.imgUpload.faData.url;
					} else if (this.imgFour && this.$refs.imgUpload.faData.url !== undefined) {
						this.$refs.imgUpload.findTrue();
						this.logo_url = this.$refs.imgUpload.faData.url;
						this.form.logo_url = this.$refs.imgUpload.faData.url;
					} else if (this.imgFive && this.$refs.imgUpload.faData.url !== undefined) {
						this.$refs.imgUpload.findTrue();
						this.colorful_log = this.$refs.imgUpload.faData.url;
						this.form.colorful_log = this.$refs.imgUpload.faData.url;
					}
					// this.$refs.imgUpload.faData.url = "";
					this.$refs.imgUpload.getimgLists();
					this.upImg = false;
				} else {
					this.$message.warning("请选择一张照片");
				}
			},
			chooseImg5() {
				this.imgSecond = false;
				this.imgFirst = false;
				this.imgThird = false;
				this.imgFour = false;
				this.imgFive = true;
				this.upImg = true;
			},
			chooseImg4() {
				this.imgSecond = false;
				this.imgFirst = false;
				this.imgThird = false;
				this.imgFour = true;
				this.imgFive = false;
				this.upImg = true;
			},
			chooseImg3() {
				this.imgSecond = false;
				this.imgFirst = false;
				this.imgFour = false;
				this.imgFive = false;
				this.imgThird = true;
				this.upImg = true;
			},
			chooseImg2() {
				this.imgFirst = false;
				this.imgThird = false;
				this.imgFour = false;
				this.imgFive = false;
				this.imgSecond = true;
				this.upImg = true;
			},
			// 选择图片
			chooseImg() {
				this.imgThird = false;
				this.imgSecond = false;
				this.imgFour = false;
				this.imgFirst = true;
				this.imgFive = false;
				this.upImg = true;
			},
			// 改变状态
			changeStatus(res) {
				this.form = JSON.parse(JSON.stringify(res));
				// this.handleEdit();
				this.actionType = "edit";
				const {
					city_name,
					company_name,
					...rest
				} = this.form;
				this.form = rest;
				editcommunity(this.form).then((msg) => {
					if (msg.code !== 200) return this.$message("获取状态失败");
				});
			},
			// 点击清空事件
			clearInput() {
				(this.searchForm = {
					page: 1,
					size: 15,
				}),
				this.initList();
			},
			// 车库
			handleCar(res) {
				this.$router.push({
					path: "/garage/index",
					query: {
						id: res.id
					},
				});
			},
			// 移除图片
			removePic() {
				this.imageUrl = "";
				this.form.xiaoqu_img = "";
				this.imgDis = false;
				this.$forceUpdate();
			},
			removePic1(item) {
				let index = this.form.home_imgs.indexOf(item)
				if (index > -1) {
					this.form.home_imgs.splice(index, 1)
				}
				// this.form.home_img = "";
				this.imgDis2 = false;
				this.$forceUpdate();
			},
			removePic2() {
				this.form.sales_img = "";
				this.imgDis3 = false;
				this.$forceUpdate();
			},
			removePic3() {
				this.logo_url = "";
				this.form.logo_url = "";
				this.imgDis4 = false;
				this.$forceUpdate();
			},
			removePic4() {
				this.colorful_log = "";
				this.form.colorful_log = "";
				this.imgDis5 = false;
				this.$forceUpdate();
			},
			// 发送短信
			handleMessage(res) {
				const confirmId = {
					id: res.id,
				};
				this.confirmPublic("发送短信", sellMsg, confirmId);
				// sellMsg(res).then((req) => {
				//   if (req.code == 200) {
				//     this.$message.success("发送成功！");
				//     this.userOpen = false;
				//     this.initList();
				//   } else {
				//     this.$message.error("发送失败！");
				//   }
				// });
			},
			// 跳转楼栋管理
			handleBuild(res) {
				this.$router.push({
					path: "/community/building",
					query: {
						id: res.id
					},
				});
			},
			// 跳转小区标签
			handleFloor(res) {
				this.$router.push({
					path: "/community/tag",
					query: {
						id: res.id
					},
				});
			},
			handlecuxiaoSuccess(res) {
				this.form.sales_img = res.data.path;
				this.$forceUpdate();
			},
			handleLogoSuccess(res, file) {
				this.logo_url = res.data.path;
				this.form.logo_url = this.logo_url;
				this.$forceUpdate();
			},
			handleColorLogoSuccess(res, file) {
				this.colorful_log = res.data.path;
				this.form.colorful_log = this.colorful_log;
				this.$forceUpdate();
			},
			handleAvatarSuccess(res, file) {
				this.imageUrl = res.data.path;
				this.form.xiaoqu_img = this.imageUrl;
				this.$forceUpdate();

				//   this.form.sales_img = this.imageUrl;
				//   console.log(this.imageUrl);
			},
			beforeAvatarUpload(file) {
				const isJPG =
					file.type === "image/jpeg" ||
					file.type === "image/png" ||
					file.type === "image/jpeg" ||
					file.type === "image/webp";

				if (!isJPG) {
					this.$message.error("上传头像图片只能是 JPG 格式!");
				}

				return isJPG;
			},
			// 公司下拉
			getCompanysLists() {
				getShowCompany().then((res) => {
					this.companysList = res.data;
				});
			},
			// 活动下拉
			getComAct() {
				const form = {
					select: 1,
				};
				getcommunityAct().then((res) => {
					this.comAct = res.data;
				});
			},
			// 城市下拉
			getCityeLists() {
				const form = {
					select: 1,
				};
				getCityeList(form).then((res) => {
					this.cityList = res.data.records;
				});
			},
			// 选择城市
			changeCity(res) {
				const cityIds = {
					city_id: res,
					is_page: 0
				};
				getdistrictList(cityIds).then((req) => {
					this.regionList = req.data.records;
				});
			},
			// 选择区域
			changeRegion(res) {
				let city = this.cityList.find(item => item.id == this.form.city_id);
				let region = this.regionList.find(item => item.id == this.form.region_id);
				this.form.address = city && region ? city.title + region.title : '';
			},
			// 获取子组件的值
			getCityData(res) {
				this.searchForm.city_id = res;
			},
			confirmPublic(text, url, data) {
				this.$confirm(`确定${text}?`, `${text}`, {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(async () => {
					const res = await url(data);
					if (res.code !== 200) return this.$message.error("操作失败");
					this.$message.success(`${text}成功!`);
					this.initList();
				});
			},
			// 生成短码
			getShortImg(req) {
				const confirmId = {
					id: req.id,
				};
				this.confirmPublic("生成短码", getShort, confirmId);
			},
			// 生成短链
			getShortUrl(req) {
				const confirmId = {
					id: req.id,
				};
				this.confirmPublic("生成短链", getShortUrl, confirmId);
			},
			// 生成小程序码
			getappImg(req) {
				const appData = {
					id: req.id,
				};
				this.$confirm("确定生成小程序码？", "生成小程序码", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(async () => {
					const res = await getappImgs(appData);
					if (res.code !== 200) return this.$message.error("生成失败!");
					this.$message.success("成功生成");
					this.initList();
				});
			},
			// 打开小程序码
			getApps(res) {
				this.appOpen = true;
				this.title = "小程序码";
				this.appShortUrl = '';
				this.appUrl = res.share_img;
			},
			// 打开小程序短链
			getAppsl(res) {
				this.appOpen = true;
				this.title = "小程序短链";
				this.appUrl = '';
				this.appShortUrl = res.urllink;
			},
			changeDate() {
				this.$forceUpdate()
			},
			// 点击确定
			submitForms() {
				const {
					city_name,
					company_name,
					created_at,
					...rest
				} = this.form;
				this.form = rest;

				if (this.form.date && this.form.date.length) {
					this.form.sales_time_begin = this.form.date[0];
					this.form.sales_time = this.form.date[1];
					delete this.form.date;
				} else {
					this.form.sales_time_begin = 0;
					this.form.sales_time = 0;
				}

				this.submitForm();
			},
			// 重置
			reset() {
				this.form = {
					status: undefined,
					title: undefined,
					xiaoqu_img: undefined,
					is_hidden: undefined,
					follow_day: undefined,
				};
				this.imageUrl = undefined;
				this.logo_url = undefined;
				this.colorful_log = undefined;
			},
			// 新增弹窗
			handleNewAdd() {
				this.title = "新增";
				if (this.$refs.imgUpload) {
					this.$refs.imgUpload.faData.url = "";
				}
				this.reset();
				this.handleAdd();
				this.$nextTick(() => {
					this.form.live_status = 0;
					this.form.status = 1;
					this.form.hosting = 0;
					this.imageUrl = "";
					this.logo_url = "";
					this.colorful_log = "";
					this.form.logo_url = "";
					this.form.colorful_log = "";
					this.form.home_img = "";
					this.form.sales_img = "";
					this.$refs.form.clearValidate();
				});
				this.form.status = 1;
				this.form.live_status = 0;
				this.form.is_hidden = 0;
				this.form.follow_day = 30;
				this.form.service_version = 2;
				this.form.rule_engine_version = '2.0';
				this.form.lock_hour = 72;
				this.form.lock_num = 2;
			},
			// convertTimestamp(timestamp) {
			// 	const date = new Date(timestamp * 1000);
			// 	const year = date.getFullYear();
			// 	const month = ("0" + (date.getMonth() + 1)).slice(-2);
			// 	const day = ("0" + date.getDate()).slice(-2);
			// 	const hours = ("0" + date.getHours()).slice(-2);
			// 	const minutes = ("0" + date.getMinutes()).slice(-2);

			// 	return `${year}-${month}-${day} ${hours}-${minutes}分`;
			// },
			// 修改弹窗
			handleClick(row) {
				this.title = "修改";
				this.imageUrl = "";
				this.form.home_img = "";
				this.form.sales_img = "";

				this.form = JSON.parse(JSON.stringify(row));

				if (this.form.sales_time == 0) {
					this.form.sales_time = "";
				} else {
					if (this.form.sales_time_begin && this.form.sales_time) {
						this.form.date = [this.form.sales_time_begin, this.form.sales_time]
					}
				}
				if (this.form.hosting === undefined) {
					this.form.hosting = 0;
				}

				this.changeCity(this.form.city_id);
				this.imageUrl = row.xiaoqu_img;
				this.logo_url = row.logo_url;
				this.colorful_log = row.colorful_log;
				if (this.$refs.imgUpload) {
					this.$refs.imgUpload.faData.url = "";
				}
				if (this.imageUrl) {
					this.imgDis = true;
				}
				if (this.form.sales_img) {
					this.imgDis3 = true;
				}
				if (this.form.home_img) {
					this.imgDis2 = true;
				}
				if (this.form.logo_url) {
					this.imgDis4 = true;
				}
				if (this.form.colorful_log) {
					this.imgDis5 = true;
				}
				this.handleEdit();
			},
			// 关闭弹窗
			getout() {
				this.addOrEditOpen = false;
				this.$nextTick(() => {
					this.$refs.form.clearValidate();
					this.regionList = [];
				});
			},
			// 重置
			resets() {
				this.$refs.citySearchData.searchForm.city_id = undefined;
				this.searchForm = {
					city_id: undefined,
				};
				this.regionList = [];
				this.initList();
			},
			onCreated(editor) {
				this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
			},
			onCreated0(editor) {
				this.editor0 = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
			},
			onCreated1(editor) {
				this.editor1 = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
			},
			onChange(editor) {
				console.log('onchange=====================:', editor);
			},
			onChange0(editor) {
				console.log('onchange=====================:', editor);
			},
			onChange1(editor) {
				console.log('onchange=====================:', editor);
			},
			onCreated2(editor) {
				this.editor2 = Object.seal(editor);
			},
			onChange2(editor) {
				console.log('onchange2=====================:', editor);
			},
			// 添加租期规则
			addRentRule() {
				if (!this.form.rent_price_rule_vos) {
					this.$set(this.form, 'rent_price_rule_vos', []);
				}
				this.form.rent_price_rule_vos.push({ tenancy: 30, rent_price: 0 });
			},
			// 删除租期规则
			removeRentRule(index) {
				this.form.rent_price_rule_vos.splice(index, 1);
			},
		},
	beforeDestroy() {
		const editor = this.editor;
		if (editor == null) return;
		editor.destroy(); // 组件销毁时，及时销毁编辑器
		const editor0 = this.editor0;
		if (editor0 == null) return;
		editor0.destroy(); // 组件销毁时，及时销毁编辑器
		const editor1 = this.editor1;
		if (editor1 == null) return;
		editor1.destroy(); // 组件销毁时，及时销毁编辑器
		const editor2 = this.editor2;
		if (editor2 == null) return;
		editor2.destroy(); // 组件销毁时，及时销毁编辑器
	},
	});
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
	/deep/.dialogHeight2 .el-dialog__body {
		overflow-y: auto;
	}

	/deep/.dialogHeight .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	.chooseImg {
		display: flex;
		align-items: center;
	}

	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.avatar-wrapper {
		position: relative;
	}

	.avatar-wrapper img.avatar {
		max-width: 100%;
		max-height: 100%;
	}

	.avatar-wrapper .el-icon-close {
		position: absolute;
		top: 5px;
		right: 5px;
		font-size: 18px;
		color: #fff;
		background-color: rgba(0, 0, 0, 0.5);
		padding: 5px;
		border-radius: 50%;
		cursor: pointer;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;

		display: flex;
		align-items: center;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 150px;
		height: 150px;
		line-height: 150px;
		text-align: center;
		border: 1px solid #dcdfe6;
	}

	.avatar {
		width: 150px;
		height: 150px;
		display: block;
	}

	.el-icon-close {
		position: absolute;
		top: 0;
		right: 7vh;
		cursor: pointer;
	}

	.closes {
		right: 54vh;
	}

	.el-icon-close:hover {
		color: #409eff;
	}

	.el-icon-close2 {
		position: absolute;
		top: 0;
		right: 55vh;
		cursor: pointer;
	}

	/deep/ .el-dialog__body {
		height: 65vh;
	}
</style>



// WEBPACK FOOTER //
// src/views/community/community.vue